import Component from './Expand.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionExpand', Component);
  },
};
